import React from 'react';
// import Banner from './Banner';

const LoadStore = () => {

  return(
    <div className="collections placeholder">
      <div className="sidenav">
        {[...Array(10)].map((e, i) => {
          return <li className="items" key={i}><a><h5> </h5></a></li>
        })}
      </div>
      <div className="cards">
        {/*<BannerEmpty />*/}
        <div className="category">
          <div className="scrollblock"></div>
          <h3>Category</h3>
        </div>
        <div className="container">
          {[...Array(18)].map((e, i) => {
            return <li key={i} id={i}><a><div className="empty"></div><div className="content"><h5 className="title"> </h5><p className="tagline"> </p></div></a></li>
          })}
        </div>
      </div>
    </div>
  );
}

export default LoadStore;


// WEBPACK FOOTER //
// ./src/components/LoadStore.js